<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import Dialog from 'primevue/dialog';
import { useGradeStore } from '@/stores/useGradeStore.js';


export default {
  name: "index-questions",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      questions: [],
      lesson: null,
      lessons: [],
      chapter: null,
      chapters: [],
      visible: false
    };
  },
  components: {
    Breadcrumb,
    Dropdown,
    Dialog
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    basePath() {
      return this.isCourseScope ? `/courses/${this.courseId}/question-bank` : `/${this.gradeSlug}/questions`;
    },
    // Legacy routes use a singular "question/add" segment for add/edit while the
    // list route is plural "questions" (pre-existing inconsistency) — course
    // routes use "question-bank" consistently everywhere.
    addPath() {
      return this.isCourseScope ? `${this.basePath}/add` : `/${this.gradeSlug}/question/add`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [...base, { name: "بنك الأسئلة", path: this.basePath }];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: "السؤال", path: this.basePath },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() { return this.resolvedGrade?.id ?? null; },
  },
  methods: {
    fetchQuestions() {
      const params = this.isCourseScope ? { course_id: this.courseId } : { academic_year_id: this.gradeId };
      if (this.lesson?.id) {
        params.lesson_id = this.lesson.id;
      }

      axios
          .get('/questions', { params })
          .then((response) => {
            this.questions = response.data.data;
            // this.paggination = response.data.data.meta.total;
          })
          .catch((error) => {
            this.questions = [];
          });
    },

    deleteQuestion(question_id) {
      Swal.fire({
        title: "هل تريد الحذف ؟",
        text: "سيتم الحذف نهائيا",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "رجوع",
        confirmButtonText: "احذف",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
              .delete(`questions/${question_id}`)
              .then(({ data }) => {
                if (data.status == true) {
                  Swal.fire("تم الحذف بنجاح", "", "success");
                  this.questions = this.questions.filter(r => r.id !== question_id);
                } else {
                  Swal.fire("", data.message, "error");
                }
              });
        }
      });
    },

    fetchChapters() {
      const params = this.isCourseScope
          ? { type: 2, course_id: this.courseId }
          : { type: 2, academic_year_id: this.gradeId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.chapters = response.data.data; })
          .catch(() => {});
    },
    fetchLessons() {
      const chapterId = this.chapter?.id;
      const params = this.isCourseScope
          ? { type: 3, course_id: this.courseId, parent_id: chapterId }
          : { type: 3, academic_year_id: this.gradeId, parent_id: chapterId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.lessons = response.data.data; })
          .catch(() => {});
    },

    customLabelChapter(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelLesson(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    this.fetchQuestions();
    this.fetchChapters();
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">
    <div class="filter my-3">
      <div class="filter-head">
        <div class="row d-flex align-items-center gap-4 w-75">
          <h4 class="mb-0 col-lg-2 col-12">السؤال</h4>
          <div class="row d-flex gap-lg-0 gap-2 col-lg-10 col-12 mb-lg-0 mb-2">
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="chapter" :options="chapters" showClear :optionLabel="customLabelChapter" placeholder="اختر الباب" class="w-full md:w-14rem" @update:model-value="fetchLessons" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="lesson" :options="lessons" showClear :optionLabel="customLabelLesson" placeholder="اختر الدرس" class="w-full md:w-14rem" @update:model-value="fetchQuestions" />
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <router-link :to="addPath" class="btn PrimaryButton">إضافة سؤال</router-link>
        </div>
      </div>
    </div>
    <div class="row reservation-table">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">الصورة</th>
              <th scope="col">العنوان</th>
              <th scope="col">نوع السؤال</th>
              <th scope="col">درجة السؤال</th>
              <th scope="col">صعوبة السؤال</th>
              <th scope="col">الدرس</th>
              <th scope="col">التحكم</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(question, index) in questions"
                :key="question.id"
            >
              <td data-label="ID">{{ index + 1 }}</td>
              <td data-label="الصورة">
                <img @click="visible = true" v-if="question.image" :src="question.image" alt="question Image" style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px; cursor: pointer" />
                <span v-else>--- </span>

                <Dialog v-model:visible="visible" modal header="الصورة" :dismissableMask="true" :style="{ width: '70vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                  <img v-if="question.image" :src="question.image" alt="question Image" style="width: 100%; height: auto; object-fit: cover; border-radius: 5px;" />
                </Dialog>
              </td>
              <td data-label="الاسم">{{ question.title }}</td>
              <td data-label=">نوع السؤال">{{ question.type }}</td>
              <td data-label=">نوع السؤال">{{ question.degree }}</td>
              <td data-label="صعوبة السؤال">
                <span v-if="question.difficulty_level === 'easy'">سهل</span>
                <span v-else-if="question.difficulty_level === 'medium'">متوسط</span>
                <span v-else-if="question.difficulty_level === 'hard'">صعب</span>
              </td>
              <td data-label="الدرس">{{ question.lesson ? question.lesson?.title : '---' }}</td>
              <td data-label="التحكم">
                <router-link class="btn btn-primary text-white mx-1"
                             :tooltip="'تعديل'"
                             flow="up"
                             :to="isCourseScope ? `${basePath}/edit/${question.id}` : `/${gradeSlug}/question/edit/${question.id}`">
                  <i class="pi pi-pencil"></i>
                </router-link>
                <button class="btn btn-danger text-white mx-1"
                        type="button"
                        :tooltip="`حذف`"
                        flow="up"
                        @click="deleteQuestion(question.id)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="questions.length === 0">
              <td colspan="8" class="text-center">لا يوجد بيانات</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>